export default [
  {
    path: "/",
    name: "ProjectsPage",
    component: () => import("@/views/projects/ProjectsPage.vue"),
    meta: {
      requiresAuth: true,
      authorize: [
        "SUPER_ADMIN",
        "ADMIN",
        "ADMINISTRATION",
        "CHIEF",
        "AGENCY",
        "ACCOUNTING"
      ]
    }
  },
  {
    path: "/imports",
    name: "ImportsPage",
    component: () => import("@/views/imports/ImportsPage.vue")
  },
  {
    path: "/plannings",
    name: "PlanningsPage",
    component: () => import("@/views/plannings/PlanningsPage.vue"),
    meta: {
      requiresAuth: true,
      authorize: [
        "SUPER_ADMIN",
        "ADMIN",
        "ADMINISTRATION",
        "SEWING",
        "CHIEF",
        "AGENCY",
        "ACCOUNTING"
      ]
    }
  },
  {
    path: "/editions",
    name: "EditionsPage",
    component: () => import("@/views/editions/EditionsPage.vue"),
    meta: {
      requiresAuth: true,
      authorize: [
        "SUPER_ADMIN",
        "ADMIN",
        "ADMINISTRATION",
        "CHIEF",
        "AGENCY",
        "ACCOUNTING"
      ]
    }
  },
  {
    path: "/settings",
    name: "SettingsPage",
    component: () => import("@/views/settings/SettingsPage.vue"),
    meta: {
      requiresAuth: true,
      authorize: [
        "SUPER_ADMIN",
        "ADMIN",
        "ADMINISTRATION",
        "CHIEF",
        "AGENCY",
        "ACCOUNTING"
      ]
    }
  },

  {
    path: "/dashboard",
    name: "DashboardPage",
    component: () => import("@/views/dashboard/DashboardPage.vue"),
    meta: {
      requiresAuth: true,
      authorize: [
        "SUPER_ADMIN",
        "ADMIN",
        "ADMINISTRATION",
        "CHIEF",
        "AGENCY",
        "ACCOUNTING"
      ]
    }
  },

  {
    path: "/consultation/:project_uuid",
    name: "ConsultationPage",
    component: () => import("@/views/consultation/ConsultationPage.vue"),
    meta: {
      requiresAuth: true,
      authorize: [
        "SUPER_ADMIN",
        "ADMIN",
        "ADMINISTRATION",
        "CHIEF",
        "AGENCY",
        "ACCOUNTING"
      ]
    }
  }
];
